import './styles';

import React from 'react';

import { formatNumberWithDelimiter } from 'shared/number_helper';
import TruncatableText from 'details/components/truncatable_text';
import LoadingMessage from 'details/components/loading_message';
import CitationsChart from './citations_chart';

export default class CitationsTab extends React.Component {
    render() {
        return (
            <div className="CitationsTab">
                {this.props.publication.citationsLoaded ? (
                    this.content
                ) : (
                    <LoadingMessage text={I18n.t('citations_tab.loading')} />
                )}
            </div>
        );
    }

    get content() {
        if (this.props.publication.timesCited) {
            return this.citationData;
        } else {
            return this.noCitationsMessage;
        }
    }

    get noCitationsMessage() {
        return <div className="CitationsTab-empty-message">{I18n.t('citations_tab.no_citations')}</div>;
    }

    get citationData() {
        return (
            <div className="CitationsTab-content">
                {this.citationSummary}
                {this.citationsYearlyChart}
                {this.citationList}
            </div>
        );
    }

    get citationSummary() {
        let count = this.props.publication.timesCited;
        let formattedCount = formatNumberWithDelimiter(count);
        let visibleCount = this.props.publication.citations.length;

        return (
            <div className="CitationsTab-summary">
                <span className="count">
                    <span className="number">{formattedCount}</span>
                    <span className="text">{I18n.t('citations', { count: count })}</span>
                </span>
                <span className="content">
                    {I18n.htmlSafe('citations_tab.description', {
                        visibleCount: visibleCount,
                        formattedCount: formattedCount,
                        count: count
                    })}{' '}
                    {count > visibleCount
                        ? I18n.htmlSafe('citations_tab.visit_in_dimensions', {
                              publicationPage: this.props.publication.dimensionsURI
                          })
                        : null}
                </span>
                <span className="button">
                    <a href={this.props.publication.dimensionsURI} target="_blank">
                        {I18n.t('buttons.view_in_dimensions')}
                    </a>
                </span>
            </div>
        );
    }

    get citationList() {
        return (
            <ol className="CitationsTab-list">
                {this.props.publication.citations.map((citation, index) => (
                    <CitationItem citation={citation} maxLength={this.maxAbstractLength} key={index} />
                ))}
            </ol>
        );
    }

    get citationsYearlyChart() {
        if (!this.displayChart) return;

        return <CitationsChart data={this.props.publication.citationsYearlyAggregation} />;
    }

    get displayChart() {
        return this.props.publication.citationsYearlyAggregation.length > 1;
    }

    get maxAbstractLength() {
        return this.displayChart ? 100 : 250;
    }
}

const CitationItem = props => {
    let url;

    if (props.citation.doi) {
        url = props.citation.doiURI;
    } else if (props.citation.pmid) {
        url = props.citation.pubmedURI;
    }

    return (
        <li className="CitationsTab-citation-item">
            <h2 className="title">
                <a href={url} target="_blank">
                    {props.citation.title}
                </a>
            </h2>
            <CitationPublicationMetadata {...props} />
            {props.citation.authorNames ? (
                <div className="metadata">
                    <strong>Authors: </strong>
                    <TruncatableText text={props.citation.authorNames} maxLength={100} />
                </div>
            ) : null}
            {props.citation.abstract ? (
                <div className="abstract">
                    <TruncatableText text={props.citation.abstract} maxLength={props.maxLength} />
                </div>
            ) : null}
        </li>
    );
};

const CitationPublicationMetadata = props => {
    let publicationDate = props.citation.publicationDate;
    let journal = props.citation.journal;
    let title = journal && journal.title;
    let date = publicationDate ? publicationDate.format('MMMM YYYY') : null;

    if (title && date) {
        return (
            <div className="metadata">
                {I18n.htmlSafe('citations_tab.article.full_description', { title: title, date: date })}
            </div>
        );
    } else if (title) {
        return (
            <div className="metadata">
                {I18n.htmlSafe('citations_tab.article.journal_description', { title: title })}
            </div>
        );
    } else if (date) {
        return (
            <div className="metadata">{I18n.htmlSafe('citations_tab.article.date_description', { date: date })}</div>
        );
    }

    return null;
};
